export const ADD_TRANSACTION_RECEIPT = 'ADD_TRANSACTION_RECEIPT';
export const UPDATE_SUBSCRIPTION_MANAGED = 'UPDATE_SUBSCRIPTION_MANAGED';
export const COMPLETE_PURCHASE = 'COMPLETE_PURCHASE';
export const COMPLETE_PURCHASE_SUCCESS = 'COMPLETE_PURCHASE_SUCCESS';
export const PURCHASES_RESTORED = 'PURCHASES_RESTORED';
export const TOGGLE_PRO = 'TOGGLE_PRO';
export const TOGGLE_SUBSCRIPTION = 'TOGGLE_SUBSCRIPTION';
